<template>
  <div class="user-agreement-wrap">
    <div class="user-agreement" v-html="agreement">
      <!-- <h2>用户服务协议</h2>
      <div class="container">
        <div class="block" v-for="(block, i) in agreement" :key="i">
          <p>{{ block.name }}</p>
          <div
            class="paragraph"
            v-for="(paragraph, j) in block.children"
            :key="j"
          >
            <p>{{ paragraph.str }}</p>
            <div
              class="by-law"
              v-for="(bylaw, k) in paragraph.children"
              :key="k"
            >
              <p>{{ bylaw.str }}</p>
            </div>
            <p></p>
          </div>
        </div>
      </div> -->
    </div>
  </div>
</template>
<script>
// import { agreement } from "@/utils/global.js";
import { getUserAgreement } from "../../utils/api/user";
export default {
  data() {
    return {
      agreement: ""
    };
  },
  mounted() {
    getUserAgreement().then((res) => {
      if (res.success) {
        this.agreement = res.data.contents;
      }
    });
  }
};
</script>

<style lang="scss" scoped>
.user-agreement-wrap {
  background-color: #f9f9f9;
  color: #333333;
  font-size: 14px;
  padding-bottom: 50px;
  .user-agreement {
    overflow: hidden;
    width: 335px;
    margin: 0 auto;
    text-align: left;
    h2 {
      text-align: center;
    }
    .container {
      p {
        line-height: 32px;
        font-size: 14px;
        min-height: 32px;
      }
      .block {
        & > p {
          font-size: 16px;
          font-weight: 700;
        }
        .paragraph {
          .by-law {
          }
        }
      }
    }
  }
}
</style>
